import { TableContainer } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@mui/material/Tooltip";
import TombSvgComponent from "assets/icons/svg/tomb";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import { postalCodeLabel } from "helper/postalCodeFormat";
import React from "react";
import { useHistory } from "react-router";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    paddingLeft: "20px !important",
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);

const MemberTableList = ({
  list,
  loading,
  perPage,
  page,
  setPage,
  isPeopleMember,
  peopleTotalList,
  peoplePage,
  setPeoplePage,
  total,
  setTypeUser,
  get_contact,
  setOpen,
  setMemberToRemove,
  family_members,
  openInvitationModelHandler,
  openDisableMemberUserHandler,
  setAccount,
  setOpenDrawer,
}) => {
  const history = useHistory();

  const postalLabel = postalCodeLabel();
  const orgDetails = getOrganizationInfoFromLocalStorage();

  const generalOptions = localStorage.getItem("generalOptions")
    ? JSON.parse(localStorage.getItem("generalOptions"))
    : {};

  const getOptions = (key) => {
    return {
      hidden: generalOptions?.[key]?.hidden || false,
    };
  };
  const genderOptions = getOptions("Sex");
  const relationshipOptions = getOptions("Relationship");

  const columns = [
    {
      id: "first_name",
      label: "NAME",
    },
    {
      id: "account_permission",
      label: "FAMILY ADMIN",
    },
    ...(genderOptions?.hidden
      ? []
      : [
          {
            id: "gender",
            label: "SEX",
          },
        ]),
    {
      id: "date_of_birth",
      label: "DOB",
    },
    {
      id: "zip_code",
      label: postalLabel?.toUpperCase(),
    },
    ...(relationshipOptions?.hidden
      ? []
      : [
          {
            id: "relationship",
            label: "RELATIONSHIP",
          },
        ]),
    {
      id: "events",
      label: "MEMBERS PORTAL USER",
    },
    {
      id: "action",
      label: "Action",
      className: "sticky-header-column",
    },
  ];

  return (
    <div
      className="current-class-table-container"
      style={{
        padding: "17px",
      }}
    >
      <div>
        <TableContainer className="scroll-table">
          <Table
            class="main-tables"
            aria-label="collapsible table"
            style={{ width: "100%" }}
          >
            <TableHead className="charges-table sticky-table-header">
              <TableRow>
                {columns?.map((column) => (
                  <TableCellHead
                    key={column.id}
                    align="left"
                    className={`class__header__cell year__head ${column.className}`}
                  >
                    {column?.id !== "action" && (
                      <div
                        className="d-flex h-100 justify-content-start align-items-center"
                        style={{ gap: "10px" }}
                      >
                        {column.label}
                      </div>
                    )}
                  </TableCellHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              className="tran-table-body"
              style={{
                backgroundColor: "white",
              }}
            >
              {loading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <div className="user__loader" style={{ height: "320px" }}>
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : list?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <h6 style={{ height: "320px", marginTop: "100px" }}>
                      No Data Found
                    </h6>
                  </TableCell>
                </TableRow>
              ) : (
                list?.map((row, i) => (
                  <TableRow
                    sx={{ "& > *": { borderBottom: "unset" } }}
                    onClick={() => {
                      setAccount(row);
                      setOpenDrawer(true);
                    }}
                  >
                    <TableCellBody align="left">
                      <div
                        className="user-cotainer-home col m-0"
                        style={{
                          minWidth: "250px",
                        }}
                      >
                        <div className="user-icon d-flex flex-row position-relative">
                          <Avatar
                            className="avatar"
                            style={{
                              background: row.backGround,
                              height: "50px",
                              borderRadius: "6px",
                              width: "50px",
                              marginLeft: "-15px",
                            }}
                            alt={`${row?.first_name} ${row?.last_name}`}
                            src={
                              row?.profile_img
                                ? row?.profile_img
                                : "/example.jpg"
                            }
                          ></Avatar>
                          {row?.mark_as_deceased && (
                            <span
                              style={{
                                position: "absolute",
                                bottom: "0",
                                right: "-10px",
                              }}
                            >
                              {/* <TombSvgComponent
                    fillcolor={"#302f2f"}
                    height={20}
                    width={20}
                  /> */}
                              <TombSvgComponent fillcolor={"#2555ef"} />
                            </span>
                          )}
                        </div>
                        <div className="name-container flex-row-reverse w-100 text-left mr-5">
                          <Tooltip
                            title={`${row?.first_name} ${row?.last_name}${
                              row?.mark_as_deceased ? "-DECEASED" : ""
                            }`}
                            placement="top"
                          >
                            <p
                              className="id-container w-100 table-field-hover-data"
                              style={{
                                wordBreak: "break-all",
                                whiteSpace: "nowrap",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                history.push(
                                  `/member-details/${row?.account_id}/family-member`,
                                  row
                                );
                              }}
                            >
                              {`${row?.first_name} ${row?.last_name}`}
                              <span
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {row?.mark_as_deceased ? "-DECEASED" : ""}
                              </span>
                            </p>
                          </Tooltip>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.account_permission === "admin" ? "YES" : "NO"}
                      </div>
                    </TableCellBody>
                    {!genderOptions?.hidden && (
                      <TableCellBody align="left">
                        <div className="row-data-gender">
                          {row.gender ? row.gender : "-"}
                        </div>
                      </TableCellBody>
                    )}
                    <TableCellBody align="left">
                      <div className="row-data-DOB">
                        {row.date_of_birth
                          ? formatDate({
                              date: row.date_of_birth,
                              formatType: "defaultWithUTC",
                            })
                          : "-"}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data-account">
                        {row.zip_code || "-"}
                      </div>
                    </TableCellBody>
                    {!relationshipOptions?.hidden && (
                      <TableCellBody align="left">
                        <div className="row-data-upcoming">
                          {row?.relationship?.[0] ?? "-"}
                        </div>
                      </TableCellBody>
                    )}
                    <TableCellBody align="left">
                      <div className="row-data-upcoming">
                        {row?.haveMemberPortalAccount ? "Yes" : "-"}
                      </div>
                    </TableCellBody>
                    <TableCellBody
                      align="left"
                      className="sticky-body-column"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div style={{ cursor: "pointer" }}>
                        <Action
                          style={{
                            color: "#4D5565",
                            minWidth: "44px",
                            height: "24px",
                          }}
                          onEditClick={() => {
                            // if (setFamilyMember) setFamilyMember(true);
                            // setUserFamily(true);
                            setTypeUser(true);
                            // get_contact(row?.account_id);
                            history.push(
                              `/member-details/${row?.account_id}`,
                              row
                            );
                          }}
                          onDeleteClick={() => {
                            setMemberToRemove(row);
                            setOpen(true);
                          }}
                          onInviteClick={
                            orgDetails.memberPortal
                              ? () => {
                                  openInvitationModelHandler(row);
                                }
                              : false
                          }
                          inviteText={
                            row?.haveMemberPortalAccount
                              ? "Re-send members portal invitation"
                              : "Invite to members portal"
                          }
                          popOverWidth={
                            row?.haveMemberPortalAccount ? 300 : 250
                          }
                          onDisableMemberUserClick={
                            row?.haveMemberPortalAccount
                              ? () => {
                                  openDisableMemberUserHandler(row);
                                }
                              : false
                          }
                          disableMemberUserText={
                            row?.haveMemberPortalAccount
                              ? "Disable member portal user"
                              : ""
                          }
                        />
                      </div>
                    </TableCellBody>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {family_members?.length <= perPage ? (
        ""
      ) : (
        <div className="member__family__pagination">
          <Pagination
            count={Math.ceil(
              isPeopleMember ? peopleTotalList / perPage : total / perPage
            )}
            color="primary"
            variant="outlined"
            page={isPeopleMember ? peoplePage : page}
            onChange={(event, p) => {
              isPeopleMember ? setPeoplePage(p) : setPage(p);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MemberTableList;
